//5、双吊轮孔排
import makerjs from "makerjs";
// inputParam,model,this.myHolesNum,outParam,fixedParam
// (D,X,Y,area,plate,markers,myHolesNum,glassW,glassH,markShift,markShiftTwo,markShiftThree,markShiftFour,markHolesOneD)
function HangWheelHoleTwoRow(inputParam, model, myHolesNum, outParam, fixedParam, zoom, θCut, rCut,cutLine,cutFilletRadius){
var D=inputParam.D,X=inputParam.X,W=inputParam.W,Y=inputParam.Y,area=inputParam.area,myZoom=zoom*1, myθCut = θCut, myrCut = rCut,
plate = model.plate, cutPlate = model.cutPlate, markers = model.markers,
glassW=outParam.glassW,glassH=outParam.glassH,
   markShift=fixedParam.markShift*1,markShiftTwo=fixedParam.markShiftTwo*1,
   markShiftThree=fixedParam.markShiftThree*1,markShiftFour=fixedParam.markShiftFour*1,markHolesOneD=fixedParam.markHolesOneD*1,
   d = D*1*myZoom,
   w = W*1*myZoom,
    x0 = X*1*myZoom,
    y0 = Y*1*myZoom;
    if(plate.models===undefined||plate.models===""){
      console.log("1111111111111111");
      plate.models={};
              }        
              if(cutPlate.models===undefined||cutPlate.models===""){
                  console.log("22222222222");
                  //cutPlate.models={};
                  cutPlate.models={};
              }
              if(markers.models===undefined||markers.models===""){            
                  console.log("333333333333");
                  markers.models={};
              }
   //d = D*1,
   //x0 = X*1,
  // y0 = Y*1;
   if(d!==0){
      var TxtD="∮"+D;
     }
   if(w!==0){
    var TxtW=W;
   }
   if(x0!==0){          
   var TxtX=X;
   }
   if(y0!==0){          
    var TxtY=Y;
   }
  //在A区域 计算孔的位置       
  var xa=x0,ya=glassH * 1-y0,
  //B区域//只有Y标注没有X标注 
  xb=glassW * 1/2,yb=glassH * 1-y0,
  //C区域
  xc=glassW * 1-x0,yc=glassH * 1-y0,
  //D区域
  //只有X标注没有Y标注 
  xd=x0,yd=glassH * 1/2,
  //E区域
  //只有X标注没有Y标注 
  xe=glassW * 1/2,ye=glassH * 1/2,
  //F区域
  //只有X标注没有Y标注 
  xf=glassW * 1-x0,yf=glassH * 1/2,
  //在G区域 计算孔的位置
  xg=x0,yg=y0,
  //在H区域 计算孔的位置
  //只标注Y
  xh=glassW*1/2,yh=y0,
  //在I区域 计算孔的位置
  xi=glassW*1-x0,yi=y0;
  if(area==4){

//双吊轮孔排 D位置孔
      //标记双吊轮孔排 A位置孔排上
      var myHwhtrHolesAUp= new makerjs.models.Holes(d/2, [[xa, ya]]);
      var myHwhtrHolesMarkAUp = new makerjs.models.Square(0); //孔的原点       
      myHwhtrHolesMarkAUp.origin = [xa, ya];      
      var myHwhtrXMarkAUp = new makerjs.models.Square(0);      
      myHwhtrXMarkAUp.origin =[xa, ya];      
      var myHwhtrYMarkAUp = new makerjs.models.Square(0);      
      myHwhtrYMarkAUp.origin = [xa, ya]; 
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtrHolesMarkAUp, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
makerjs.model.addPath(myHwhtrHolesMarkAUp, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
makerjs.model.addPath(myHwhtrHolesMarkAUp, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
makerjs.model.addPath(myHwhtrHolesMarkAUp, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtrHolesMarkAUp, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtrHolesMarkAUp, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
makerjs.model.addPath(myHwhtrXMarkAUp, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
makerjs.model.addCaption(myHwhtrXMarkAUp, TxtX, [-x0,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
/*****************************************************************************/     
makerjs.model.addPath(myHwhtrYMarkAUp, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
makerjs.model.addCaption(myHwhtrYMarkAUp, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
/*****************************************************************************/ 
      //标记双吊轮孔排 A位置孔排下
      var myHwhtrHolesADn= new makerjs.models.Holes(d/2, [[xa, ya-w]]);
      var myHwhtrHolesMarkADn = new makerjs.models.Square(0); //孔的原点       
      myHwhtrHolesMarkADn.origin = [xa, ya-w];      
      var myHwhtrXMarkADn = new makerjs.models.Square(0);      
      myHwhtrXMarkADn.origin =[xa, ya-w];      
      var myHwhtrYMarkADn = new makerjs.models.Square(0);      
      myHwhtrYMarkADn.origin = [xa, ya-w]; 
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtrHolesMarkADn, new makerjs.paths.Line([0,0], [-x0, 0]));//从孔圆心出发X方向横向标线
makerjs.model.addPath(myHwhtrHolesMarkADn, new makerjs.paths.Line([0,0], [0, w]));//从孔圆心出发Y方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtrHolesMarkADn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
makerjs.model.addCaption(myHwhtrHolesMarkADn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
/*****************************************************************************/   
makerjs.model.addPath(myHwhtrXMarkADn, new makerjs.paths.Line([0,0], [0, w]));//W短标线
makerjs.model.addCaption(myHwhtrXMarkADn, TxtW, [0-markShift,0], [0-markShift, w]);//W文字标注
/*****************************************************************************/
 //标记双吊轮孔排 G位置孔排上
  //画孔
     var myHwhtrHolesGUp= new makerjs.models.Holes(d/2, [[xg, yg]]);
      var myHwhtrHolesMarkGUp = new makerjs.models.Square(0); //孔的原点       
      myHwhtrHolesMarkGUp.origin = [xg, yg];      
      var myHwhtrXMarkGUp = new makerjs.models.Square(0);      
      myHwhtrXMarkGUp.origin = [xg, yg];      
      var myHwhtrYMarkGUp = new makerjs.models.Square(0);      
      myHwhtrYMarkGUp.origin = [xg, yg];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtrXMarkGUp, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发Y方向横向标线
makerjs.model.addPath(myHwhtrXMarkGUp, new makerjs.paths.Line([0,0], [-x0, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtrHolesMarkGUp, new makerjs.paths.Line([0,0], [d, d]));//直径标线
makerjs.model.addCaption(myHwhtrHolesMarkGUp, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addCaption(myHwhtrXMarkGUp, TxtX, [-x0,markShift], [0, markShift]);//X文字标注
/*****************************************************************************/    
makerjs.model.addCaption(myHwhtrYMarkGUp, TxtY, [-markShiftTwo, -y0], [-markShiftTwo,0]);//Y文字标注
/*****************************************************************************/ 
 //标记双吊轮孔排 G位置孔排下
  //画孔
  var myHwhtrHolesGDn= new makerjs.models.Holes(d/2, [[xg, yg+w]]);
      var myHwhtrHolesMarkGDn = new makerjs.models.Square(0); //孔的原点       
      myHwhtrHolesMarkGDn.origin = [xg, yg+w];      
      var myHwhtrXMarkGDn = new makerjs.models.Square(0);      
      myHwhtrXMarkGDn.origin = [xg, yg+w];      
      var myHwhtrYMarkGDn = new makerjs.models.Square(0);      
      myHwhtrYMarkGDn.origin = [xg, yg+w];  
/*****************************************************************************/  
makerjs.model.addPath(myHwhtrXMarkGDn, new makerjs.paths.Line([0,0], [0, -w]));////从孔圆心出发Y方向横向标线
//makerjs.model.addPath(myHwhtrXMarkGDn, new makerjs.paths.Line([0,0], [x0+markShiftTwo, 0]));////从孔圆心出发X方向竖向标线
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtrHolesMarkGDn, new makerjs.paths.Line([0,0], [d, d]));//直径标线
makerjs.model.addCaption(myHwhtrHolesMarkGDn, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
/*****************************************************************************/ 
makerjs.model.addPath(myHwhtrXMarkGDn, new makerjs.paths.Line([0,0], [0, -w]));//W短标线
makerjs.model.addCaption(myHwhtrXMarkGDn, TxtW, [0-markShift, -w], [0-markShift,0]);//W文字标注
/*****************************************************************************/ 
plate.models["TypeHoles_HangWheelHoleTwoRow_DAUp"+myHolesNum]=myHwhtrHolesAUp;
cutPlate.models["TypeHoles_HangWheelHoleTwoRow_DAUp"+myHolesNum]=myHwhtrHolesAUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_DAUp"+myHolesNum]=myHwhtrHolesAUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_MarkDAUp"+myHolesNum]=myHwhtrHolesMarkAUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkDAUp"+myHolesNum]=myHwhtrXMarkAUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkDAUp"+myHolesNum]=myHwhtrYMarkAUp;
/*****************************************************************************/
plate.models["TypeHoles_HangWheelHoleTwoRow_DADn"+myHolesNum]=myHwhtrHolesADn;
cutPlate.models["TypeHoles_HangWheelHoleTwoRow_DADn"+myHolesNum]=myHwhtrHolesADn;
markers.models["TypeHoles_HangWheelHoleTwoRow_DADn"+myHolesNum]=myHwhtrHolesADn;
markers.models["TypeHoles_HangWheelHoleTwoRow_MarkDADn"+myHolesNum]=myHwhtrHolesMarkADn;
markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkDADn"+myHolesNum]=myHwhtrXMarkADn;
markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkDADn"+myHolesNum]=myHwhtrYMarkADn;
/*****************************************************************************/ 
plate.models["TypeHoles_HangWheelHoleTwoRow_DGUp"+myHolesNum]=myHwhtrHolesGUp;
cutPlate.models["TypeHoles_HangWheelHoleTwoRow_DGUp"+myHolesNum]=myHwhtrHolesGUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_DGUp"+myHolesNum]=myHwhtrHolesGUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_MarkDGUp"+myHolesNum]=myHwhtrHolesMarkGUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkDGUp"+myHolesNum]=myHwhtrXMarkGUp;
markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkDGUp"+myHolesNum]=myHwhtrYMarkGUp;
/*****************************************************************************/ 
plate.models["TypeHoles_HangWheelHoleTwoRow_DGDn"+myHolesNum]=myHwhtrHolesGDn;
cutPlate.models["TypeHoles_HangWheelHoleTwoRow_DGDn"+myHolesNum]=myHwhtrHolesGDn;
markers.models["TypeHoles_HangWheelHoleTwoRow_DGDn"+myHolesNum]=myHwhtrHolesGDn;
markers.models["TypeHoles_HangWheelHoleTwoRow_MarkDGDn"+myHolesNum]=myHwhtrHolesMarkGDn;
markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkDGDn"+myHolesNum]=myHwhtrXMarkGDn;
markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkDGDn"+myHolesNum]=myHwhtrYMarkGDn;
/*****************************************************************************/  
  }else if(area==6){

      //双吊轮孔排 F位置孔
            //标记双吊轮孔排 C位置孔排上
            var myHwhtrHolesCUp= new makerjs.models.Holes(d/2, [[xc, yc]]);
            var myHwhtrHolesMarkCUp = new makerjs.models.Square(0); //孔的原点       
            myHwhtrHolesMarkCUp.origin = [xc, yc];      
            var myHwhtrXMarkCUp = new makerjs.models.Square(0);      
            myHwhtrXMarkCUp.origin =[xc, yc];      
            var myHwhtrYMarkCUp = new makerjs.models.Square(0);      
            myHwhtrYMarkCUp.origin = [xc, yc]; 
      /*****************************************************************************/ 
      makerjs.model.addPath(myHwhtrHolesMarkCUp, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftTwo]));//Y轴加长标线
      makerjs.model.addPath(myHwhtrHolesMarkCUp, new makerjs.paths.Line([0,0], [x0, 0]));//从孔圆心出发X方向横向标线
      // makerjs.model.addPath(myHwhtrHolesMarkCUp, new makerjs.paths.Line([x0,y0], [x0+markShiftThree, y0]));//X轴加长标线
      makerjs.model.addPath(myHwhtrHolesMarkCUp, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myHwhtrHolesMarkCUp, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myHwhtrHolesMarkCUp, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myHwhtrXMarkCUp, new makerjs.paths.Line([0,y0+markShift], [x0, y0+markShift]));//X短标线
      makerjs.model.addCaption(myHwhtrXMarkCUp, TxtX, [0,y0+markShiftTwo], [x0, y0+markShiftTwo]);//X文字标注
      /*****************************************************************************/     
      makerjs.model.addPath(myHwhtrYMarkCUp, new makerjs.paths.Line([0,0], [0, y0]));//Y短标线
      makerjs.model.addCaption(myHwhtrYMarkCUp, TxtY, [-markShift,0], [-markShift, y0]);//Y文字标注
      /*****************************************************************************/ 
            //标记双吊轮孔排 A位置孔排下
            var myHwhtrHolesCDn= new makerjs.models.Holes(d/2, [[xc, yc-w]]);
            var myHwhtrHolesMarkCDn = new makerjs.models.Square(0); //孔的原点       
            myHwhtrHolesMarkCDn.origin = [xc, yc-w];      
            var myHwhtrXMarkCDn = new makerjs.models.Square(0);      
            myHwhtrXMarkCDn.origin =[xc, yc-w];      
            var myHwhtrYMarkCDn = new makerjs.models.Square(0);      
            myHwhtrYMarkCDn.origin = [xc, yc-w]; 
      /*****************************************************************************/ 
      // makerjs.model.addPath(myHwhtrHolesMarkCDn, new makerjs.paths.Line([0,0], [x0, 0]));//从孔圆心出发X方向横向标线
      makerjs.model.addPath(myHwhtrHolesMarkCDn, new makerjs.paths.Line([0,0], [0, w]));//从孔圆心出发Y方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myHwhtrHolesMarkCDn, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
      makerjs.model.addCaption(myHwhtrHolesMarkCDn, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
      /*****************************************************************************/   
      makerjs.model.addPath(myHwhtrXMarkCDn, new makerjs.paths.Line([0,0], [0, w]));//W短标线
      makerjs.model.addCaption(myHwhtrXMarkCDn, TxtW, [0-markShift,0], [0-markShift, w]);//W文字标注
      /*****************************************************************************/
       //标记双吊轮孔排 G位置孔排上
        //画孔
           var myHwhtrHolesIUp= new makerjs.models.Holes(d/2, [[xi, yi]]);
            var myHwhtrHolesMarkIUp = new makerjs.models.Square(0); //孔的原点       
            myHwhtrHolesMarkIUp.origin = [xi, yi];      
            var myHwhtrXMarkIUp = new makerjs.models.Square(0);      
            myHwhtrXMarkIUp.origin = [xi, yi];      
            var myHwhtrYMarkIUp = new makerjs.models.Square(0);      
            myHwhtrYMarkIUp.origin = [xi, yi];  
      /*****************************************************************************/  
      //makerjs.model.addPath(myHwhtrHolesMarkIUp, new makerjs.paths.Line([x0,y0], [x0+markShiftTwo, y0]));//Y轴加长标线
      //makerjs.model.addPath(myHwhtrHolesMarkIUp, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftTwo]));//X轴加长标线
      makerjs.model.addPath(myHwhtrXMarkIUp, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发Y方向横向标线
      makerjs.model.addPath(myHwhtrXMarkIUp, new makerjs.paths.Line([0,0], [x0, 0]));////从孔圆心出发X方向竖向标线
      /*****************************************************************************/ 
      makerjs.model.addPath(myHwhtrHolesMarkIUp, new makerjs.paths.Line([0,0], [d, d]));//直径标线
      makerjs.model.addCaption(myHwhtrHolesMarkIUp, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
      /*****************************************************************************/ 
      //makerjs.model.addPath(myHwhtrXMarkIUp, new makerjs.paths.Line([0,y0+markShift], [x0, y0+markShift]));//X短标线
      makerjs.model.addCaption(myHwhtrXMarkIUp, TxtX, [0,markShift], [x0, markShift]);//X文字标注
      /*****************************************************************************/    
      //makerjs.model.addPath(myHwhtrYMarkIUp, new makerjs.paths.Line([x0+markShift,0], [x0+markShift, y0]));//Y短标线
      makerjs.model.addCaption(myHwhtrYMarkIUp, TxtY, [-markShiftTwo, -y0], [-markShiftTwo,0]);//Y文字标注
      /*****************************************************************************/ 
       //标记双吊轮孔排 G位置孔排下
        //画孔
        var myHwhtrHolesIDn= new makerjs.models.Holes(d/2, [[xi, yi+w]]);
            var myHwhtrHolesMarkIDn = new makerjs.models.Square(0); //孔的原点       
            myHwhtrHolesMarkIDn.origin = [xi, yi+w];      
            var myHwhtrXMarkIDn = new makerjs.models.Square(0);      
            myHwhtrXMarkIDn.origin = [xi, yi+w];      
            var myHwhtrYMarkIDn = new makerjs.models.Square(0);      
            myHwhtrYMarkIDn.origin = [xi, yi+w];  
      /*****************************************************************************/ 
      makerjs.model.addPath(myHwhtrHolesMarkIDn, new makerjs.paths.Line([0,0], [d, d]));//直径标线
      makerjs.model.addCaption(myHwhtrHolesMarkIDn, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
      /*****************************************************************************/ 
      makerjs.model.addPath(myHwhtrXMarkIDn, new makerjs.paths.Line([0,0], [0, -w]));//W短标线
      makerjs.model.addCaption(myHwhtrXMarkIDn, TxtW, [0-markShift, -w], [0-markShift,0]);//W文字标注
      /*****************************************************************************/ 
      plate.models["TypeHoles_HangWheelHoleTwoRow_FCUp"+myHolesNum]=myHwhtrHolesCUp;
      cutPlate.models["TypeHoles_HangWheelHoleTwoRow_FCUp"+myHolesNum]=myHwhtrHolesCUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_FCUp"+myHolesNum]=myHwhtrHolesCUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_MarkFCUp"+myHolesNum]=myHwhtrHolesMarkCUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkFCUp"+myHolesNum]=myHwhtrXMarkCUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkFCUp"+myHolesNum]=myHwhtrYMarkCUp;
      /*****************************************************************************/
      plate.models["TypeHoles_HangWheelHoleTwoRow_FCDn"+myHolesNum]=myHwhtrHolesCDn;
      cutPlate.models["TypeHoles_HangWheelHoleTwoRow_FCDn"+myHolesNum]=myHwhtrHolesCDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_FCDn"+myHolesNum]=myHwhtrHolesCDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_MarkFCDn"+myHolesNum]=myHwhtrHolesMarkCDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkFCDn"+myHolesNum]=myHwhtrXMarkCDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkFCDn"+myHolesNum]=myHwhtrYMarkCDn;
      /*****************************************************************************/ 
      plate.models["TypeHoles_HangWheelHoleTwoRow_FIUp"+myHolesNum]=myHwhtrHolesIUp;
      cutPlate.models["TypeHoles_HangWheelHoleTwoRow_FIUp"+myHolesNum]=myHwhtrHolesIUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_FIUp"+myHolesNum]=myHwhtrHolesIUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_MarkFIUp"+myHolesNum]=myHwhtrHolesMarkIUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkFIUp"+myHolesNum]=myHwhtrXMarkIUp;
      markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkFIUp"+myHolesNum]=myHwhtrYMarkIUp;
      /*****************************************************************************/ 
      plate.models["TypeHoles_HangWheelHoleTwoRow_FIDn"+myHolesNum]=myHwhtrHolesIDn;
      cutPlate.models["TypeHoles_HangWheelHoleTwoRow_FIDn"+myHolesNum]=myHwhtrHolesIDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_FIDn"+myHolesNum]=myHwhtrHolesIDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_MarkFIDn"+myHolesNum]=myHwhtrHolesMarkIDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkFIDn"+myHolesNum]=myHwhtrXMarkIDn;
      markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkFIDn"+myHolesNum]=myHwhtrYMarkIDn;
      /*****************************************************************************/  
  }else if(area==2){

            //双吊轮孔排 D位置孔
                  //标记双吊轮孔排 A位置孔排上
                  var myHwhtrHolesAlf= new makerjs.models.Holes(d/2, [[xa, ya]]);
                  var myHwhtrHolesMarkAlf = new makerjs.models.Square(0); //孔的原点       
                  myHwhtrHolesMarkAlf.origin = [xa, ya];      
                  var myHwhtrXMarkAlf = new makerjs.models.Square(0);      
                  myHwhtrXMarkAlf.origin =[xa, ya];      
                  var myHwhtrYMarkAlf = new makerjs.models.Square(0);      
                  myHwhtrYMarkAlf.origin = [xa, ya]; 
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhtrHolesMarkAlf, new makerjs.paths.Line([-x0,y0], [-x0, y0+markShiftTwo]));//Y轴加长标线
            makerjs.model.addPath(myHwhtrHolesMarkAlf, new makerjs.paths.Line([0,0], [-x0-markShiftThree, 0]));//从孔圆心出发X方向横向标线
            makerjs.model.addPath(myHwhtrHolesMarkAlf, new makerjs.paths.Line([-x0,y0], [-x0-markShiftThree, y0]));//X轴加长标线
            makerjs.model.addPath(myHwhtrHolesMarkAlf, new makerjs.paths.Line([0,0], [0, y0+markShiftTwo]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhtrHolesMarkAlf, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhtrHolesMarkAlf, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhtrXMarkAlf, new makerjs.paths.Line([0,y0+markShift], [-x0, y0+markShift]));//X短标线
            makerjs.model.addCaption(myHwhtrXMarkAlf, TxtX, [-x0,y0+markShiftTwo], [0, y0+markShiftTwo]);//X文字标注
            /*****************************************************************************/     
            makerjs.model.addPath(myHwhtrYMarkAlf, new makerjs.paths.Line([-x0-markShiftTwo,0], [-x0-markShiftTwo, y0]));//Y短标线
            makerjs.model.addCaption(myHwhtrYMarkAlf, TxtY, [-x0-markShiftThree,0], [-x0-markShiftThree, y0]);//Y文字标注
            /*****************************************************************************/ 
                  //标记双吊轮孔排 A位置孔排下
                  var myHwhtrHolesArt= new makerjs.models.Holes(d/2, [[xa+w, ya]]);
                  var myHwhtrHolesMarkArt = new makerjs.models.Square(0); //孔的原点       
                  myHwhtrHolesMarkArt.origin = [xa+w, ya];      
                  var myHwhtrXMarkArt = new makerjs.models.Square(0);      
                  myHwhtrXMarkArt.origin =[xa+w, ya];      
                  var myHwhtrYMarkArt = new makerjs.models.Square(0);      
                  myHwhtrYMarkArt.origin = [xa+w, ya]; 
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhtrHolesMarkArt, new makerjs.paths.Line([0,0], [-x0, 0]));//从孔圆心出发X方向横向标线
            // makerjs.model.addPath(myHwhtrHolesMarkArt, new makerjs.paths.Line([0,0], [w, 0]));//从孔圆心出发Y方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhtrHolesMarkArt, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
            makerjs.model.addCaption(myHwhtrHolesMarkArt, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
            /*****************************************************************************/   
            makerjs.model.addPath(myHwhtrXMarkArt, new makerjs.paths.Line([0,0], [-w, 0]));//W短标线
            makerjs.model.addCaption(myHwhtrXMarkArt, TxtW, [-w,markShift], [0, markShift]);//W文字标注
            /*****************************************************************************/
             //标记双吊轮孔排 C位置孔排上
              //画孔
                 var myHwhtrHolesClf= new makerjs.models.Holes(d/2, [[xc, yc]]);
                  var myHwhtrHolesMarkClf = new makerjs.models.Square(0); //孔的原点       
                  myHwhtrHolesMarkClf.origin = [xc, yc];      
                  var myHwhtrXMarkClf = new makerjs.models.Square(0);      
                  myHwhtrXMarkClf.origin = [xc, yc];      
                  var myHwhtrYMarkClf = new makerjs.models.Square(0);      
                  myHwhtrYMarkClf.origin = [xc, yc];  
            /*****************************************************************************/  
            //makerjs.model.addPath(myHwhtrHolesMarkClf, new makerjs.paths.Line([x0,y0], [x0+markShiftTwo, y0]));//Y轴加长标线
            //makerjs.model.addPath(myHwhtrHolesMarkClf, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftTwo]));//X轴加长标线
            makerjs.model.addPath(myHwhtrXMarkClf, new makerjs.paths.Line([0,0], [0, y0]));////从孔圆心出发Y方向横向标线
            makerjs.model.addPath(myHwhtrXMarkClf, new makerjs.paths.Line([0,0], [x0, 0]));////从孔圆心出发X方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhtrHolesMarkClf, new makerjs.paths.Line([0,0], [d, d]));//直径标线
            makerjs.model.addCaption(myHwhtrHolesMarkClf, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
            /*****************************************************************************/ 
            //makerjs.model.addPath(myHwhtrXMarkClf, new makerjs.paths.Line([0,y0+markShift], [x0, y0+markShift]));//X短标线
            makerjs.model.addCaption(myHwhtrXMarkClf, TxtX, [0,markShift], [x0, markShift]);//X文字标注
            /*****************************************************************************/    
            //makerjs.model.addPath(myHwhtrYMarkClf, new makerjs.paths.Line([x0+markShift,0], [x0+markShift, y0]));//Y短标线
            makerjs.model.addCaption(myHwhtrYMarkClf, TxtY, [-markShiftTwo, 0], [-markShiftTwo,y0]);//Y文字标注
            /*****************************************************************************/ 
             //标记双吊轮孔排 G位置孔排下
              //画孔
              var myHwhtrHolesCrt= new makerjs.models.Holes(d/2, [[xc-w, yc]]);
                  var myHwhtrHolesMarkCrt = new makerjs.models.Square(0); //孔的原点       
                  myHwhtrHolesMarkCrt.origin = [xc-w, yc];      
                  var myHwhtrXMarkCrt = new makerjs.models.Square(0);      
                  myHwhtrXMarkCrt.origin = [xc-w, yc];      
                  var myHwhtrYMarkCrt = new makerjs.models.Square(0);      
                  myHwhtrYMarkCrt.origin = [xc-w, yc];  
            /*****************************************************************************/  
            makerjs.model.addPath(myHwhtrXMarkCrt, new makerjs.paths.Line([0,0], [w, 0]));////从孔圆心出发Y方向横向标线
            //makerjs.model.addPath(myHwhtrXMarkCrt, new makerjs.paths.Line([0,0], [x0+markShiftTwo, 0]));////从孔圆心出发X方向竖向标线
            /*****************************************************************************/ 
            makerjs.model.addPath(myHwhtrHolesMarkCrt, new makerjs.paths.Line([0,0], [d, d]));//直径标线
            makerjs.model.addCaption(myHwhtrHolesMarkCrt, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
            /*****************************************************************************/ 
            // makerjs.model.addPath(myHwhtrXMarkCrt, new makerjs.paths.Line([0,0], [0, -w]));//W短标线
            makerjs.model.addCaption(myHwhtrXMarkCrt, TxtW, [0, -markShift], [w,-markShift]);//W文字标注
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleTwoRow_BAlf"+myHolesNum]=myHwhtrHolesAlf;
            cutPlate.models["TypeHoles_HangWheelHoleTwoRow_BAlf"+myHolesNum]=myHwhtrHolesAlf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_BAlf"+myHolesNum]=myHwhtrHolesAlf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_MarkBAlf"+myHolesNum]=myHwhtrHolesMarkAlf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkBAlf"+myHolesNum]=myHwhtrXMarkAlf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkBAlf"+myHolesNum]=myHwhtrYMarkAlf;
            /*****************************************************************************/
            plate.models["TypeHoles_HangWheelHoleTwoRow_BArt"+myHolesNum]=myHwhtrHolesArt;
            cutPlate.models["TypeHoles_HangWheelHoleTwoRow_BArt"+myHolesNum]=myHwhtrHolesArt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_BArt"+myHolesNum]=myHwhtrHolesArt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_MarkBArt"+myHolesNum]=myHwhtrHolesMarkArt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkBArt"+myHolesNum]=myHwhtrXMarkArt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkBArt"+myHolesNum]=myHwhtrYMarkArt;
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleTwoRow_BClf"+myHolesNum]=myHwhtrHolesClf;
            cutPlate.models["TypeHoles_HangWheelHoleTwoRow_BClf"+myHolesNum]=myHwhtrHolesClf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_BClf"+myHolesNum]=myHwhtrHolesClf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_MarkBClf"+myHolesNum]=myHwhtrHolesMarkClf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkBClf"+myHolesNum]=myHwhtrXMarkClf;
            markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkBClf"+myHolesNum]=myHwhtrYMarkClf;
            /*****************************************************************************/ 
            plate.models["TypeHoles_HangWheelHoleTwoRow_BCrt"+myHolesNum]=myHwhtrHolesCrt;
            cutPlate.models["TypeHoles_HangWheelHoleTwoRow_BCrt"+myHolesNum]=myHwhtrHolesCrt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_BCrt"+myHolesNum]=myHwhtrHolesCrt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_MarkBCrt"+myHolesNum]=myHwhtrHolesMarkCrt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkBCrt"+myHolesNum]=myHwhtrXMarkCrt;
            markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkBCrt"+myHolesNum]=myHwhtrYMarkCrt;
            /*****************************************************************************/  
  }else if(area==8){
//双吊轮孔排 H位置孔
                      //标记双吊轮孔排 C位置孔排上
                      var myHwhtrHolesGlf= new makerjs.models.Holes(d/2, [[xg, yg]]);
                      var myHwhtrHolesMarkGlf = new makerjs.models.Square(0); //孔的原点       
                      myHwhtrHolesMarkGlf.origin = [xg, yg];      
                      var myHwhtrXMarkGlf = new makerjs.models.Square(0);      
                      myHwhtrXMarkGlf.origin =[xg, yg];      
                      var myHwhtrYMarkGlf = new makerjs.models.Square(0);      
                      myHwhtrYMarkGlf.origin = [xg, yg]; 
                /*****************************************************************************/ 
                makerjs.model.addPath(myHwhtrHolesMarkGlf, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
                makerjs.model.addCaption(myHwhtrHolesMarkGlf, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
                /*****************************************************************************/   
                makerjs.model.addPath(myHwhtrXMarkGlf, new makerjs.paths.Line([0,0], [-x0, 0]));//X短标线
                makerjs.model.addCaption(myHwhtrXMarkGlf, TxtX, [-x0,markShift], [0, markShift]);//X文字标注
                /*****************************************************************************/     
                makerjs.model.addPath(myHwhtrYMarkGlf, new makerjs.paths.Line([0,0], [0, -y0]));//Y短标线
                makerjs.model.addCaption(myHwhtrYMarkGlf, TxtY, [markShift,0], [markShift, -y0]);//Y文字标注
                /*****************************************************************************/ 
                      //标记双吊轮孔排 A位置孔排下
                      var myHwhtrHolesGrt= new makerjs.models.Holes(d/2, [[xg+w, yg]]);
                      var myHwhtrHolesMarkGrt = new makerjs.models.Square(0); //孔的原点       
                      myHwhtrHolesMarkGrt.origin = [xg+w, yg];      
                      var myHwhtrXMarkGrt = new makerjs.models.Square(0);      
                      myHwhtrXMarkGrt.origin =[xg+w, yg];      
                      var myHwhtrYMarkGrt = new makerjs.models.Square(0);      
                      myHwhtrYMarkGrt.origin = [xg+w, yg]; 
                /*****************************************************************************/ 
            //     makerjs.model.addPath(myHwhtrHolesMarkGrt, new makerjs.paths.Line([0,0], [-x0, 0]));//从孔圆心出发X方向横向标线
                // makerjs.model.addPath(myHwhtrHolesMarkGrt, new makerjs.paths.Line([0,0], [w, 0]));//从孔圆心出发Y方向竖向标线
                /*****************************************************************************/ 
                makerjs.model.addPath(myHwhtrHolesMarkGrt, new makerjs.paths.Line([0,0], [d, -d]));//直径标线
                makerjs.model.addCaption(myHwhtrHolesMarkGrt, TxtD, [0,0], [d+markHolesOneD, -d-markHolesOneD]);//直径文字标注
                /*****************************************************************************/   
                makerjs.model.addPath(myHwhtrXMarkGrt, new makerjs.paths.Line([0,0], [-w, 0]));//W短标线
                makerjs.model.addCaption(myHwhtrXMarkGrt, TxtW, [-w,markShift], [0, markShift]);//W文字标注
                /*****************************************************************************/
                 //标记双吊轮孔排 I位置孔排上
                  //画孔
                     var myHwhtrHolesIlf= new makerjs.models.Holes(d/2, [[xi, yi]]);
                      var myHwhtrHolesMarkIlf = new makerjs.models.Square(0); //孔的原点       
                      myHwhtrHolesMarkIlf.origin = [xi, yi];      
                      var myHwhtrXMarkIlf = new makerjs.models.Square(0);      
                      myHwhtrXMarkIlf.origin = [xi, yi];      
                      var myHwhtrYMarkIlf = new makerjs.models.Square(0);      
                      myHwhtrYMarkIlf.origin = [xi, yi];  
                /*****************************************************************************/  
                //makerjs.model.addPath(myHwhtrHolesMarkIlf, new makerjs.paths.Line([x0,y0], [x0+markShiftTwo, y0]));//Y轴加长标线
                //makerjs.model.addPath(myHwhtrHolesMarkIlf, new makerjs.paths.Line([x0,y0], [x0, y0+markShiftTwo]));//X轴加长标线
                makerjs.model.addPath(myHwhtrXMarkIlf, new makerjs.paths.Line([0,0], [0, -y0]));////从孔圆心出发Y方向横向标线
                makerjs.model.addPath(myHwhtrXMarkIlf, new makerjs.paths.Line([0,0], [x0, 0]));////从孔圆心出发X方向竖向标线
                /*****************************************************************************/ 
                makerjs.model.addPath(myHwhtrHolesMarkIlf, new makerjs.paths.Line([0,0], [d, d]));//直径标线
                makerjs.model.addCaption(myHwhtrHolesMarkIlf, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
                /*****************************************************************************/ 
                //makerjs.model.addPath(myHwhtrXMarkIlf, new makerjs.paths.Line([0,y0+markShift], [x0, y0+markShift]));//X短标线
                makerjs.model.addCaption(myHwhtrXMarkIlf, TxtX, [0,markShift], [x0, markShift]);//X文字标注
                /*****************************************************************************/    
                //makerjs.model.addPath(myHwhtrYMarkIlf, new makerjs.paths.Line([x0+markShift,0], [x0+markShift, y0]));//Y短标线
                makerjs.model.addCaption(myHwhtrYMarkIlf, TxtY, [-markShiftTwo, 0], [-markShiftTwo,-y0]);//Y文字标注
                /*****************************************************************************/ 
                 //标记双吊轮孔排 G位置孔排下
                  //画孔
                  var myHwhtrHolesIrt= new makerjs.models.Holes(d/2, [[xi-w, yi]]);
                      var myHwhtrHolesMarkIrt = new makerjs.models.Square(0); //孔的原点       
                      myHwhtrHolesMarkIrt.origin = [xi-w, yi];      
                      var myHwhtrXMarkIrt = new makerjs.models.Square(0);      
                      myHwhtrXMarkIrt.origin = [xi-w, yi];      
                      var myHwhtrYMarkIrt = new makerjs.models.Square(0);      
                      myHwhtrYMarkIrt.origin = [xi-w, yi];  
                /*****************************************************************************/  
                makerjs.model.addPath(myHwhtrXMarkIrt, new makerjs.paths.Line([0,0], [w, 0]));////从孔圆心出发Y方向横向标线
                //makerjs.model.addPath(myHwhtrXMarkIrt, new makerjs.paths.Line([0,0], [x0+markShiftTwo, 0]));////从孔圆心出发X方向竖向标线
                /*****************************************************************************/ 
                makerjs.model.addPath(myHwhtrHolesMarkIrt, new makerjs.paths.Line([0,0], [d, d]));//直径标线
                makerjs.model.addCaption(myHwhtrHolesMarkIrt, TxtD, [0, 0], [d+markHolesOneD,d+markHolesOneD]);//直径文字标注
                /*****************************************************************************/ 
                // makerjs.model.addPath(myHwhtrXMarkIrt, new makerjs.paths.Line([0,0], [0, -w]));//W短标线
                makerjs.model.addCaption(myHwhtrXMarkIrt, TxtW, [0, -markShift], [w,-markShift]);//W文字标注
                /*****************************************************************************/ 
                plate.models["TypeHoles_HangWheelHoleTwoRow_HGlf"+myHolesNum]=myHwhtrHolesGlf;
                cutPlate.models["TypeHoles_HangWheelHoleTwoRow_HGlf"+myHolesNum]=myHwhtrHolesGlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_HGlf"+myHolesNum]=myHwhtrHolesGlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_MarkHGlf"+myHolesNum]=myHwhtrHolesMarkGlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkHGlf"+myHolesNum]=myHwhtrXMarkGlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkHGlf"+myHolesNum]=myHwhtrYMarkGlf;
                /*****************************************************************************/
                plate.models["TypeHoles_HangWheelHoleTwoRow_HGrt"+myHolesNum]=myHwhtrHolesGrt;
                cutPlate.models["TypeHoles_HangWheelHoleTwoRow_HGrt"+myHolesNum]=myHwhtrHolesGrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_HGrt"+myHolesNum]=myHwhtrHolesGrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_MarkHGrt"+myHolesNum]=myHwhtrHolesMarkGrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkHGrt"+myHolesNum]=myHwhtrXMarkGrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkHGrt"+myHolesNum]=myHwhtrYMarkGrt;
                /*****************************************************************************/ 
                plate.models["TypeHoles_HangWheelHoleTwoRow_HIlf"+myHolesNum]=myHwhtrHolesIlf;
                cutPlate.models["TypeHoles_HangWheelHoleTwoRow_HIlf"+myHolesNum]=myHwhtrHolesIlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_HIlf"+myHolesNum]=myHwhtrHolesIlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_MarkHIlf"+myHolesNum]=myHwhtrHolesMarkIlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkHIlf"+myHolesNum]=myHwhtrXMarkIlf;
                markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkHIlf"+myHolesNum]=myHwhtrYMarkIlf;
                /*****************************************************************************/ 
                plate.models["TypeHoles_HangWheelHoleTwoRow_HIrt"+myHolesNum]=myHwhtrHolesIrt;
                cutPlate.models["TypeHoles_HangWheelHoleTwoRow_HIrt"+myHolesNum]=myHwhtrHolesIrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_HIrt"+myHolesNum]=myHwhtrHolesIrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_MarkHIrt"+myHolesNum]=myHwhtrHolesMarkIrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_XMarkHIrt"+myHolesNum]=myHwhtrXMarkIrt;
                markers.models["TypeHoles_HangWheelHoleTwoRow_YMarkHIrt"+myHolesNum]=myHwhtrYMarkIrt;
                /*****************************************************************************/  
 }

myHolesNum++;
return{plate,cutPlate, markers,myHolesNum}
};


export default HangWheelHoleTwoRow;